import React, { Component } from 'react';
import Dialog from '../../../../commonModules/interface/Dialog';
import { isEmpty } from 'lodash';
import { InputSelect, InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline';
import { toast } from 'react-toastify';

class FormDefaultShop extends Component {
    state = {
        default_shop_id: "",
        default_shop_display: {label: "", value: ""},
    }

    createShopList = () => {
        const list = []
        const { SHOPS } = this.props
            Object.values(SHOPS).map( shop => { 
                list.push ({
                    value: shop.id, 
                    label:shop.name, 
                    disabled: !!shop.shop_disabled } 
                )
            })
        
        return list
    }

    handleSelect = (option) => {
        
        this.setState({
            default_shop_id:option.value,
            default_shop_display:option
        })
    }
    
    handleSubmit = async () => {
        if( !isEmpty(this.state.default_shop_id)){
            this.setState({
                errors: {
                    default_shop_id: ""
                }
            })

            try {
                let req = await fetch('/stocks/reappro/ext/default/shop/new',{
                    method:'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                    },
                    body: JSON.stringify({data: this.state.default_shop_id}), 
                    credentials: 'same-origin',
            
                })
                const res = await req.json()
                console.log('====================================');
                console.log("submit DefaultShop", {res});
                console.log('====================================');
                
                if(!res.error){
                    toast.success( "Magasin defaut enregisté")
                    this.props.handleClose()
                } else {
                    toast.error(  res.error.error)
                }
            } catch (error) {
                console.log('====================================');
                console.log("submit DefaultShop catch", error);
                console.log('====================================');
                toast.error(  "Un problème est survenu")
            }
        } else {
            toast.error(  "Le formulaire contient des erreurs")
            this.setState({
                errors: {
                    default_shop_id: "Veuillez remplir ce champ"
                }
            })
        }
        
        
    }
    render() {
        const shops = this.createShopList()
        return (
            <Dialog 
                title="Selectionner le magasin de réception par défault"
                block={true}
                close={this.props.handleClose}
                submitAction={this.handleSubmit}
            >
                <div>
                    <p>
                        <i>
                            Magasin dans lequel vous recevrez les produits envoyés depuis un reapprovisionnement externe
                        </i>
                    </p>
                    <p>
                        <i>
                            Si aucun magasin n'est spécifié, aucun réapprovisionnment externe ne sera possible vers votre compte
                        </i>
                    </p>
                    <InputSelectMagasin
                        options={shops}
                        value={this.state.default_shop_display}
                        onChange={ this.handleSelect }
                    /> 
                </div>
                {/* <Box p={2}>
                    <div className="pull-right">
                        <Button className="btn btn-lg btn-primary m-5" onClick={this.handleSubmit}>Valider</Button>
                        <Button className="btn btn-lg btn-default m-5" onClick={this.props.handleClose}>Annuler</Button>
                    </div>
                </Box> */}
            </Dialog>
        );
    }
}

export default FormDefaultShop;